// extracted by mini-css-extract-plugin
export default {"error":"UserAsignations_error__qtysi","searchForm":"UserAsignations_searchForm__JJAQh","icon":"UserAsignations_icon__LN2Di"};